import React, { Suspense, useEffect, useState } from "react";
import { isEmpty } from "lodash";
// hooks
import useSEO from "@/hooks/useSEO";
// utilities
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
// type
import THome from "./type";
import { useOutletContext } from "react-router-dom";
import TOutletContext from "@/cms/types/TOutletContext";
// lazy element
const MainPageItems = React.lazy(() => import("@/components/MainPageItems"));


const Render = ( props:any ) => {

    useSEO(props.locals);

    return (
        <Suspense><MainPageItems /></Suspense>
    );
    
}

const Home = ( props:THome ) => {
    console.log("Home.rendered: ", props);
    
    const { siteSettingPayload, webApplicationLanguageISOCode, _showLoader, _viewEvent } = useOutletContext<TOutletContext>();
    const [contentId] = useState(metaDataLanguageVersion("mainPageId", siteSettingPayload.languageVersions));

    useEffect(() => { return () => { _showLoader(); }},[]);
    useEffect (() => { if (contentId && !isEmpty(contentId)) _viewEvent(contentId) }, [contentId]);

    return (<Render {...props} locals={{language:webApplicationLanguageISOCode, type:"home-page", id:contentId}} />)
}

const Component = React.memo(Home, ( prevProps:THome, nextProps:THome ) => {
    console.log("Home.memo", { prevProps, nextProps });
    return true;
});

export default Component;
